import makeStyles from '@material-ui/styles/makeStyles';

export default makeStyles(theme => ({
  menuOption: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  }
}));
